import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/containers/specifics/settings/company_vendors/construction_item_settings/Page";

export const PATH = (vendorCompanyId: number): string =>
	`/settings/company_vendors/${vendorCompanyId}/construction_item_settings`;

function VendorCompanies() {
	return (
		<>
			<NskHead title="単価一覧" />
			<Component />
		</>
	);
}

export default VendorCompanies;
